import React from 'react';
import { string, bool } from 'prop-types';

import IconButton from 'components/IconButton';

import EmptyStateIcon from 'icons/emptystate-nothing-found.inline.svg';
import IconNext from 'icons/chevron.inline.svg';

import styles from './EmptyPanelState.scss';

export default function EmptyPanelState({ panelType, hideIcon, showLink }) {
  const panelMessage =
    panelType === 'alert'
      ? 'You have no alerts at this time.'
      : `You haven't defined any ${panelType}s yet!`;
  return (
    <div className={styles.EmptyPanelState}>
      {!hideIcon && <EmptyStateIcon className={styles.emptyStateIcon} />}
      <p className={styles.errorMessage}>
        {panelMessage}
      </p>
      {showLink &&
        <IconButton
          asLink
          iconRight
          linkTo={`/map/create/${panelType}`}
          label={`Create a ${panelType}`}
          withShadow
          withShadowHover
        >
          <IconNext />
        </IconButton>}
    </div>
  );
}

EmptyPanelState.propTypes = {
  panelType: string.isRequired,
  hideIcon: bool,
  showLink: bool,
};



// WEBPACK FOOTER //
// ./src/components/DataPanel/Overview/EmptyPanelState/index.js